import * as React from 'react';

import styled from '@emotion/styled';

import { Spacer } from '@shared/components/helpers';
import { useURLSearchParam } from '@shared/hooks/use_url_search_param';

import { Permission } from '@admin/components/helpers/permission';
import { accountURL } from '@admin/config/routes';
import { useTitle } from '@admin/hooks/use_title';
import { LOGISTICS } from '@admin/libraries/access_control_catalog.generated';
import { client } from '@admin/libraries/apollo';
import {
  Logistics__FulfillmentMethodTypeEnum,
  Logistics__PurchaseOrderInput,
  useAccountBreadCrumbsQueryQuery,
} from '@admin/schema';

import { AccountBreadcrumbs } from '../breadcrumbs/account_breadcrumbs';
import { LogisticsPurchaseOrderForm, DEFAULT_ADDRESS } from './form/form';

const LargeFont = styled.div`
  font-size: 2.5em;
`;

export const LogisticsNewPurchaseOrder: React.FC = () => {
  useTitle('Create Purchase Order');
  const [accountID] = useURLSearchParam('accountID');
  if (!accountID) throw new Error('undefined accountID');
  const formData: Logistics__PurchaseOrderInput = {
    accountID,
    number: '',
    fulfillmentMethod: Logistics__FulfillmentMethodTypeEnum.Freight,
    shipToAddress: DEFAULT_ADDRESS,
    fulfillmentExpectations: [],
    phoneNumber: '',
  };

  const account = useAccountBreadCrumbsQueryQuery({ client, variables: { accountID } }).data?.account;

  const onSubmit = async () => {
    window.location.href = accountURL({ id: accountID! });
  };

  return (
    <Permission resource={LOGISTICS.resource} action={LOGISTICS.actions.update}>
      {account && (
        <LargeFont>
          <AccountBreadcrumbs account={account} newItem={'New Purchase Order'} />
        </LargeFont>
      )}
      <Spacer height="10px" />
      <LogisticsPurchaseOrderForm formData={formData} onSave={onSubmit} />
    </Permission>
  );
};
